import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

import {
  GR_TOAST_KEY,
  GR_TOAST_TONE_DURATIONS,
  GR_TOAST_TONE_SEVERITIES,
  type GrToastOptions,
  type GrToastTone,
} from '@components/overlays';

@Injectable({ providedIn: 'root' })
export class GrToastService {
  private readonly messages = inject(MessageService);

  success(message: string, heading?: string): void {
    this.show({ message, heading, tone: 'success' });
  }

  error(message: string, heading?: string): void {
    this.show({ message, heading, tone: 'error' });
  }

  warning(message: string, heading?: string): void {
    this.show({ message, heading, tone: 'warning' });
  }

  info(message: string, heading?: string): void {
    this.show({ message, heading, tone: 'info' });
  }

  show(options: GrToastOptions): void {
    const tone: GrToastTone = options.tone ?? 'info';
    const duration = options.durationMs ?? GR_TOAST_TONE_DURATIONS[tone];
    // A non-positive duration means "stay until dismissed" — PrimeNG spells that `sticky`.
    const sticky = duration <= 0;

    this.messages.add({
      key: GR_TOAST_KEY,
      severity: GR_TOAST_TONE_SEVERITIES[tone],
      summary: options.heading,
      contentStyleClass: options.heading?.trim() ? undefined : 'gr-toast-content--message-only',
      detail: options.message,
      closable: options.dismissible ?? true,
      sticky,
      life: sticky ? undefined : duration,
      // PrimeNG renders `icon` as a class on an empty span, so this only supplies the font family;
      // the per-severity glyph comes from _toast.scss.
      icon: 'material-icons-outlined',
    });
  }

  clear(): void {
    this.messages.clear(GR_TOAST_KEY);
  }
}
